/**
 * Rollout fallback — tenant-scoped `/customer/consent/*` when platform routes 404.
 */
import type { CustomerMembershipItemDTO } from '../account/accountTypes.js';
import { pickLoyaltyApiTenantFromMemberships } from '../account/presenters/pickLoyaltyApiTenantFromMemberships.js';
import { hasCustomerApiTenant } from '../../shared/tenant/customerApiTenant.js';

export function resolveConsentApiFallbackTenantCode(
  browseTenantCode: string,
  memberships?: readonly CustomerMembershipItemDTO[] | null,
): string | null {
  const trimmed = browseTenantCode.trim();
  if (hasCustomerApiTenant(trimmed)) {
    return trimmed;
  }
  return pickLoyaltyApiTenantFromMemberships(memberships);
}
